import Modal, { ModalProps } from '@mui/material/Modal';
import { ReactNode } from 'react';

type PropsWithChildren<P = unknown> = P & { children?: ReactNode | undefined };

export type ModalWrapperProps = Pick<ModalProps, 'open' | 'onClose'>;

export const ModalWrapper = ({
    children,
    ...props
}: PropsWithChildren<ModalWrapperProps & { children: ReactNode }>) => (
    <Modal style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} keepMounted={false} {...props}>
        <div>{children}</div>
    </Modal>
);
